import { render, staticRenderFns } from "./historyDetailPage.vue?vue&type=template&id=dd73e75c&scoped=true"
import script from "./historyDetailPage.vue?vue&type=script&lang=js"
export * from "./historyDetailPage.vue?vue&type=script&lang=js"
import style0 from "./historyDetailPage.vue?vue&type=style&index=0&id=dd73e75c&prod&scoped=true&lang=less"
import style1 from "./historyDetailPage.vue?vue&type=style&index=1&id=dd73e75c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd73e75c",
  null
  
)

export default component.exports